import 'svelte/internal/disclose-version';

Audit[$.FILENAME] = 'src/web/concepts/audit.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">How much is inefficiency costing you?</h1>
    <div class="flex flex-col gap-6 text-lg">
      <label class="flex flex-col gap-2">
        <span>People doing repetitive work: <strong> </strong></span>
        <input type="range" min="1" max="50" class="accent-ink"/>
      </label>
      <label class="flex flex-col gap-2">
        <span>Hours each of them loses per week: <strong> </strong></span>
        <input type="range" min="1" max="20" class="accent-ink"/>
      </label>
      <label class="flex flex-col gap-2">
        <span>Average hourly cost: <strong> </strong></span>
        <input type="range" min="15" max="120" step="5" class="accent-ink"/>
      </label>
    </div>
    <div class="flex flex-col gap-2">
      <span class="opacity-60">Lost every year</span>
      <span class="font-display text-6xl md:text-8xl font-semibold tracking-tight tabular-nums"> </span>
    </div>
    <button class="btn self-start">Let's get that back</button>
  `,
		1
	),
	Audit[$.FILENAME],
	[
		[15, 4],
		[
			16,
			4,
			[
				[17, 6, [[18, 8, [[18, 44]]], [19, 8]]],
				[21, 6, [[22, 8, [[22, 49]]], [23, 8]]],
				[25, 6, [[26, 8, [[26, 35]]], [27, 8]]]
			]
		],
		[30, 4, [[31, 6], [32, 6]]],
		[34, 4]
	]
);

var root_1 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight"> </h1>
    <!>
  `,
		1
	),
	Audit[$.FILENAME],
	[[36, 4]]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-3xl flex flex-col gap-10">
  <!>
</div>`,
		1
	),
	Audit[$.FILENAME],
	[[13, 0]]
);

function Audit($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Audit);

	let people = $.tag($.state(8), 'people');
	let hours = $.tag($.state(5), 'hours');
	let rate = $.tag($.state(35), 'rate');
	let booking = $.tag($.state(false), 'booking');
	const yearly = $.tag($.derived(() => $.get(people) * $.get(hours) * $.get(rate) * 47), 'yearly');
	const format = (n) => new Intl.NumberFormat("en-GB", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_2();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var div_1 = $.sibling($.first_child(fragment_1), 3);
			var label = $.sibling($.child(div_1));
			var span = $.sibling($.child(label));
			var strong = $.sibling($.child(span));
			var text = $.only_child(strong, true);

			$.reset(span);

			var input = $.sibling(span, 2);

			$.remove_input_defaults(input);
			$.next();
			$.reset(label);

			var label_1 = $.sibling(label, 2);
			var span_1 = $.sibling($.child(label_1));
			var strong_1 = $.sibling($.child(span_1));
			var text_1 = $.only_child(strong_1, true);

			$.reset(span_1);

			var input_1 = $.sibling(span_1, 2);

			$.remove_input_defaults(input_1);
			$.next();
			$.reset(label_1);

			var label_2 = $.sibling(label_1, 2);
			var span_2 = $.sibling($.child(label_2));
			var strong_2 = $.sibling($.child(span_2));
			var text_2 = $.only_child(strong_2, true);

			$.reset(span_2);

			var input_2 = $.sibling(span_2, 2);

			$.remove_input_defaults(input_2);
			$.next();
			$.reset(label_2);
			$.next();
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var span_3 = $.sibling($.child(div_2), 3);
			var text_3 = $.only_child(span_3, true);

			$.next();
			$.reset(div_2);

			var button = $.sibling(div_2, 2);

			$.next();

			$.template_effect(
				($0, $1) => {
					$.set_text(text, $.get(people));
					$.set_text(text_1, $.get(hours));
					$.set_text(text_2, $0);
					$.set_text(text_3, $1);
				},
				[() => format($.get(rate)), () => format($.get(yearly))]
			);

			$.bind_value(
				input,
				function get() {
					return $.get(people);
				},
				function set($$value) {
					$.set(people, $$value);
				}
			);

			$.bind_value(
				input_1,
				function get() {
					return $.get(hours);
				},
				function set($$value) {
					$.set(hours, $$value);
				}
			);

			$.bind_value(
				input_2,
				function get() {
					return $.get(rate);
				},
				function set($$value) {
					$.set(rate, $$value);
				}
			);

			$.delegated('click', button, function click() {
				return $.set(booking, true);
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_1();
			var h1 = $.sibling($.first_child(fragment_2));
			var text_4 = $.only_child(h1);
			var node_1 = $.sibling(h1, 2);

			{
				let $0 = $.derived(() => `Estimated loss: ${format($.get(yearly))} per year.`);

				$.add_svelte_meta(
					() => Booking(node_1, {
						get summary() {
							return $.get($0);
						}
					}),
					'component',
					Audit,
					37,
					4,
					{ componentTag: 'Booking' }
				);
			}

			$.next();
			$.template_effect(($0) => $.set_text(text_4, `${$0 ?? ''} a year is worth a 30-minute call.`), [() => format($.get(yearly))]);
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(booking)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Audit,
			14,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Audit = $.hmr(Audit);

	import.meta.hot.accept((module) => {
		Audit[$.HMR].update(module.default);
	});
}

export default Audit;

$.delegate(['click']);